export enum AppHorseDetail {
    General = '[AppHorseDetail] General',
    Analytics = '[AppHorseDetail] Analytics',
    History = '[AppHorseDetail] History',
    Evaluations = '[AppHorseDetail] Evaluations',
    Competitions = '[AppHorseDetail] Competitions',
    Medical = '[AppHorseDetail] Medical'
}
